var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON - Discount"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91304 7.82609C7.65217 7.82609 6.52174 8.93832 6.52174 11.1628V12.1638C6.52174 14.3883 7.65217 15.5005 9.91304 15.5005C12.1739 15.5005 13.3043 14.3883 13.3043 12.1638V11.1628C13.3043 8.93832 12.1739 7.82609 9.91304 7.82609ZM11.3826 12.1638C11.3826 13.1648 10.9304 13.6097 9.91304 13.6097C8.89565 13.6097 8.44348 13.0536 8.44348 12.1638V11.1628C8.44348 10.1618 8.89565 9.71689 9.91304 9.71689C10.9304 9.71689 11.3826 10.1618 11.3826 11.1628V12.1638Z",
    fill: "#00ED26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0087 21.6178L18.5043 8.27098H20.9913L11.4957 21.6178H9.0087Z",
    fill: "#00ED26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.087 14.4995C17.8261 14.4995 16.6957 15.6117 16.6957 17.8362V18.8372C16.6957 21.0617 17.8261 22.1739 20.087 22.1739C22.3478 22.1739 23.4783 21.0617 23.4783 18.8372V17.8362C23.4783 15.6117 22.3478 14.4995 20.087 14.4995ZM21.5565 18.726C21.5565 19.727 21.1043 20.1719 20.087 20.1719C19.0696 20.1719 18.6174 19.727 18.6174 18.726V17.8362C18.6174 16.8352 19.0696 16.3903 20.087 16.3903C21.1043 16.3903 21.5565 16.8352 21.5565 17.8362V18.726Z",
    fill: "#00ED26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8696 2.34783H9.13043C5.3845 2.34783 2.34783 5.3845 2.34783 9.13043V20.8696C2.34783 24.6155 5.3845 27.6522 9.13043 27.6522H20.8696C24.6155 27.6522 27.6522 24.6155 27.6522 20.8696V9.13043C27.6522 5.3845 24.6155 2.34783 20.8696 2.34783ZM9.13043 0C4.08783 0 0 4.08783 0 9.13043V20.8696C0 25.9122 4.08783 30 9.13043 30H20.8696C25.9122 30 30 25.9122 30 20.8696V9.13043C30 4.08783 25.9122 0 20.8696 0H9.13043Z",
    fill: "#00ED26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountGreen);
export default __webpack_public_path__ + "static/media/discount-green.0ef56652cb8523a1dace63206dd6d5cd.svg";
export { ForwardRef as ReactComponent };